/**
 * IDT Summaries Tab Component
 * IDT integration for Volunteer Management
 */

import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const IDTSummariesTab = ({
  isDark,
  idtSummaries
}) => {
  return (
    <Card className={isDark ? "bg-slate-900 border-slate-800" : "bg-white"}>
      <CardHeader>
        <CardTitle className="text-lg">IDT Summaries</CardTitle>
        <CardDescription>
          Volunteer observations for IDT review and care plan integration
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {idtSummaries.map((summary) => (
            <div 
              key={summary.id}
              className={`p-4 rounded-lg border ${isDark ? "bg-slate-800 border-slate-700" : "bg-gray-50 border-gray-200"}`}
              data-testid={`idt-summary-${summary.id}`}
            >
              <div className="flex items-start justify-between mb-2">
                <div>
                  <p className="font-medium">Patient: {summary.patient_id}</p>
                  <p className={`text-sm ${isDark ? "text-gray-400" : "text-gray-600"}`}>
                    Volunteer: {summary.volunteer_id}
                  </p>
                </div>
                <Badge className="bg-blue-500/20 text-blue-400">
                  {summary.status === "pending_review" ? "Pending Review" : summary.status}
                </Badge>
              </div>
              <p className={`text-sm mb-3 ${isDark ? "text-gray-300" : "text-gray-700"}`}>
                {summary.summary_text}
              </p>
              <div className="flex gap-2">
                <Button variant="outline" size="sm">
                  Review
                </Button>
                <Button size="sm" className="bg-green-600 hover:bg-green-700">
                  Approve
                </Button>
                <Button size="sm" variant="secondary">
                  Push to Care Plan
                </Button>
              </div>
            </div>
          ))}
          {idtSummaries.length === 0 && (
            <p className={`text-center py-8 ${isDark ? "text-gray-500" : "text-gray-400"}`}>
              No IDT summaries pending review
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default IDTSummariesTab;
